import client from '@/configs/client.js';
import { BASE_URL } from '@/configs/xhconfig'

export default {
    name: 'TicketPage',
    mounted() {
        if (client.wechat) {
            let data = JSON.stringify({action: 'onIframeReady', displayStyle: 'SHOW_CUSTOM_PAGE', height: 900});
            parent.postMessage(data, 'https://payapp.weixin.qq.com');
        }
    },
    methods: {
        jump() {
            if (client.wechat) {
                let data = JSON.stringify({action: 'jumpOut', jumpOutUrl: location.origin + BASE_URL});
                parent.postMessage(data, 'https://payapp.weixin.qq.com');
            } else {
                this.$router.push('/');
            }
        }
    }
}